export const isNotEmpty = (x: any): boolean =>
    x !== undefined && x !== null && x !== ""
export const isEmpty = (x: any): boolean => !isNotEmpty(x)
export const isStringAndHasLength = (x: any): boolean =>
    typeof x === "string" && x.trim().length > 0
export const isStrLenBetween = (x: any, range: number[]): boolean =>
    typeof x === "string" &&
    range.length >= 2 &&
    x.length >= range[0] &&
    x.length <= range[1]
export const isObject = (x: any) =>
    Object.prototype.toString.call(x) === "[object Object]"
export const isArray = (x: any) => Array.isArray(x)
export const isArrayHasLength = (x: any) => isArray(x) && x.length > 0
export const isValidUserId = (id: any): boolean =>
    typeof id === "string" && id.length > 0
export const isValidMacAddress = (macAddress: any) =>
    isStringAndHasLength(macAddress) && /([0-9a-zA-Z]){12}/.test(macAddress)
